import { type User } from "./user-model";

export const displayNameForUser = (user: User): string =>
  user.fullname ?? user.username ?? user.email?.split("@")[0] ?? "";
